import Axios, { AxiosResponse } from "axios";
import { SET_API_ME, SET_APP_SETTINGS } from "./actionTypes";
import { setAssetsAssetDetails } from "@market/features/action.market";
import { getAllCompanyData } from "@company/features/action.company";
import { catchError } from "@features/utils/functions";
import SettingsService from "@services/Settings.service";
import { SettingsResponse } from "@appInterfaces/IBFAppSettings";

const RESTRICTED_BY_ADMIN = "restricted_by_admin";
const RESTRICTED_BY_PEP_SANCTION = "restricted_by_pep_sanction";
const RESTRICTED_BY_USER_STATEMENT = "restricted_by_user_statement";
const RESTRICTED_BY_RISK_RATING = "restricted_by_risk_rating";
const RESTRICTED_BY_TIER = "restricted_by_tier";
const RESTRICTED_BY_COUNTRY_UK = "restricted_by_country_uk";
const RESTRICTED_BY_2FA = "restricted_by_two_factor_authentication";

type RestrictionsInput = {
  buy_secondary_market?: string[];
  sell_secondary_market?: string[];
  crypto_trading?: string[];
};

const parseRestrictions = (restrictions: RestrictionsInput) => {
  return {
    restricted_by_user_statement:
      restrictions.crypto_trading?.includes(RESTRICTED_BY_USER_STATEMENT) ??
      false,

    sell_restricted_by_admin:
      restrictions.sell_secondary_market?.includes(RESTRICTED_BY_ADMIN) ??
      false,
    buy_restricted_by_admin:
      restrictions.buy_secondary_market?.includes(RESTRICTED_BY_ADMIN) ?? false,

    sell_restricted_by_pep_sanction:
      restrictions.sell_secondary_market?.includes(
        RESTRICTED_BY_PEP_SANCTION
      ) ?? false,
    buy_restricted_by_pep_sanction:
      restrictions.buy_secondary_market?.includes(RESTRICTED_BY_PEP_SANCTION) ??
      false,

    sell_restricted_by_user_statement:
      restrictions.sell_secondary_market?.includes(
        RESTRICTED_BY_USER_STATEMENT
      ) ?? false,
    buy_restricted_by_user_statement:
      restrictions.buy_secondary_market?.includes(
        RESTRICTED_BY_USER_STATEMENT
      ) ?? false,

    sell_restricted_by_risk_rating:
      restrictions.sell_secondary_market?.includes(RESTRICTED_BY_RISK_RATING) ??
      false,
    buy_restricted_by_risk_rating:
      restrictions.buy_secondary_market?.includes(RESTRICTED_BY_RISK_RATING) ??
      false,

    sell_restricted_by_tier:
      restrictions.sell_secondary_market?.includes(RESTRICTED_BY_TIER) ?? false,
    buy_restricted_by_tier:
      restrictions.buy_secondary_market?.includes(RESTRICTED_BY_TIER) ?? false,

    sell_restricted_by_country_uk:
      restrictions.sell_secondary_market?.includes(RESTRICTED_BY_COUNTRY_UK) ??
      false,
    buy_restricted_by_country_uk:
      restrictions.buy_secondary_market?.includes(RESTRICTED_BY_COUNTRY_UK) ??
      false,

    sell_restricted_by_2fa:
      restrictions.sell_secondary_market?.includes(RESTRICTED_BY_2FA) ?? false,
    buy_restricted_by_2fa:
      restrictions.buy_secondary_market?.includes(RESTRICTED_BY_2FA) ?? false,
  };
};
export const setApiMe =
  (userSignedIn: boolean): any =>
  (dispatch: Function) => {
    if (!userSignedIn) {
      dispatch({
        type: SET_API_ME,
        payload: false,
      });

      return Promise.resolve(undefined);
    }

    return Axios.get(`/api/users/me`)
      .then((res) => {
        const data = {
          ...res.data,
          ...parseRestrictions(res.data.restrictions),
          is_certified_or_selfcertified:
            ["certified", "self_certified"].indexOf(
              res.data.certification_status
            ) > -1,
          _2fa_enabled: res.data["2fa_enabled"],
        };

        dispatch({
          type: SET_API_ME,
          payload: data,
        });
      })
      .catch((err) => {
        catchError(err, "/");
        return Promise.reject();
      });
  };

export const setBFAppData =
  (slug: string, userSignedIn: boolean, investorId?: number) =>
  (dispatch: Function) => {
    return dispatch(getAllCompanyData(slug)).then((res: any) => {
      const tradingAssetId = res[0].trading_asset_id;
      const spvId = res[0].trading_spv_id;

      return Promise.all([
        userSignedIn && tradingAssetId && spvId && investorId
          ? dispatch(setAssetsAssetDetails(spvId, tradingAssetId, investorId))
          : undefined,
      ]).catch((err) => {
        catchError(err, "/market/");
      });
    });
  };

// tslint:disable-next-line: no-any
export const setAppSettings = (): any => (dispatch: Function) => {
  return SettingsService.get()
    .then((res: AxiosResponse<SettingsResponse>) => {
      dispatch({
        type: SET_APP_SETTINGS,
        payload: res.data,
      });
    })
    .catch((err) => {
      catchError(err, "/");
      return Promise.reject();
    });
};
